export default class {
   /**
    * Round to 2 decimals and comma seperate 1000's
    * Remove trailing zeros from decimals
    * @param {number} x
    */
   static parseNumber(x, t) {
      if(x === undefined || x === null) {
            return "";
      }
      if(typeof x === "string") {
        x = x.replace(/,/g , "");
      }
      var num = Number(x);
      if(isNaN(num)) {
          return "";
      }
      if(t !== undefined && t !== null) {
          return num
              .toFixed(t)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      } else {
          return num
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              .replace(/0*$|\.0*$|\.$/g, "");
      }
   }
	
	//show 2 decimal places always
	static parseNumberCurrency(x) {
      return x
         .toFixed(2)
         .toString()
         .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	

	static formatInt(x) {
      return x
         .toFixed(0)
         .toString()
         .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
	}
}



// WEBPACK FOOTER //
// ./src/utils/number.js